var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCircleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1667 11.8333H14.6667V11.3333V9.66666V9.16666H14.1667H11.3334V6.33332V5.83332H10.8334H9.16675H8.66675V6.33332V9.16666H5.83342H5.33342V9.66666V11.3333V11.8333H5.83342H8.66675V14.6667V15.1667H9.16675H10.8334H11.3334V14.6667V11.8333H14.1667ZM2.16675 10.5C2.16675 6.17613 5.67622 2.66666 10.0001 2.66666C14.3239 2.66666 17.8334 6.17613 17.8334 10.5C17.8334 14.8238 14.3239 18.3333 10.0001 18.3333C5.67622 18.3333 2.16675 14.8238 2.16675 10.5Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleFill);
export default __webpack_public_path__ + "static/media/add_circle_fill.5201ae65d1311fa10f78047e811e1a04.svg";
export { ForwardRef as ReactComponent };